import React, { useState, useEffect } from 'react'
import { useStyle } from "./Style";
import { Grid, Dialog, DialogTitle, DialogContent } from '@mui/material';
import {
  getPartnerGuid,
  getUserFullname,
  getAgentEmail,
  getAgentGuid,
  isAgent
} from '../../../../lib/access.es6';
import { getPartnerConfigs } from '../../../../lib/requests.es6';
import { buildAgentReferralLink } from '../../../../lib/agentReferralLink.es6';
import { PARTNERS_WITH_POLICY_NUMBER_SPECIAL_CHARACTORS } from '../../../../routes/PartnersEnum';
import ButtonInc from '../../../../shared-ui/ButtonInc';
import { getEnviroment } from '../../../../lib/utils.es6';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';


const partnerConfigs = {
  'omu_posbank': {
    staging: "https://ipp-om-uganda-gle.staging.aspin-inclusivity.com",
    production: "https://ipp-om-uganda-gle.inclusivity-aspin.com",
    partnerParam: "omu_posbank"
  },
  'om_rotary': {
    staging: "https://ipp-om-uganda-gle.staging.aspin-inclusivity.com",
    production: "https://ipp-om-uganda-gle.inclusivity-aspin.com",
    partnerParam: "om_rotary"
  },
  'om_namirembe': {
    staging: "https://ipp-om-uganda-gle.staging.aspin-inclusivity.com",
    production: "https://ipp-om-uganda-gle.inclusivity-aspin.com",
    partnerParam: "om_namirembe"
  },
  'centenary_bank': {
    staging: "https://ipp-om-uganda-gle.staging.aspin-inclusivity.com",
    production: "https://ipp-om-uganda-gle.inclusivity-aspin.com",
    partnerParam: "centenary_bank"
  },
  'dfcu_ug': {
    staging: "https://ipp-om-uganda-gle.staging.aspin-inclusivity.com",
    production: "https://ipp-om-uganda-gle.inclusivity-aspin.com",
    partnerParam: "dfcu_ug"
  },
  'om_lions': {
    staging: "https://ipp-om-uganda-gle.staging.aspin-inclusivity.com",
    production: "https://ipp-om-uganda-gle.inclusivity-aspin.com",
    partnerParam: "om_lions"
  },
  'omu_flp': {
    staging: "https://ipp-om-uganda-flp.staging.aspin-inclusivity.com",
    production: "https://ipp-om-uganda-flp.inclusivity-aspin.com",
    partnerParam: "omu_flp"
  }
};


const ProfileDetails = (props) => {
  const classes = useStyle();
  const [copied, setCopied] = useState(false);
  const [open, setOpen] = useState(false);
  const [linkConfig, setLinkConfig] = useState(null);

  useEffect(() => {
    getPartnerConfigs()
      .then((response) => {
        const data = response && response.data;
        setLinkConfig((data && data.agent_referral_link) || null);
      })
      .catch(() => setLinkConfig(null));
  }, []);


  const partnerGuid = getPartnerGuid();
  const environment = getEnviroment();
  const agentId = getUserFullname()


  const currentPartnerConfig = partnerConfigs[partnerGuid];

 
  const baseUrl = currentPartnerConfig
    ? (environment === "prod" ? currentPartnerConfig.production : currentPartnerConfig.staging)
    : '';


  // Build referral link
  const queryString = currentPartnerConfig
  ? `partner=${currentPartnerConfig.partnerParam}&created_by=${agentId}&environment=${environment}`
  : '';
  const encodedQuery = queryString ? btoa(queryString) : '';
  const configLink = isAgent()
    ? buildAgentReferralLink(linkConfig, environment, {
        name: agentId,
        guid: getAgentGuid(),
        email: getAgentEmail()
      })
    : null;
  const legacyLink = agentId && baseUrl && encodedQuery
    ? `${baseUrl}/?q=${encodedQuery}`
    : 'N/A';
  const referralLink = configLink || legacyLink;
  const showReferral = Boolean(configLink) || (currentPartnerConfig && PARTNERS_WITH_POLICY_NUMBER_SPECIAL_CHARACTORS.includes(partnerGuid));





  const handleCopy = () => {
    if (referralLink !== 'N/A') {
      navigator.clipboard.writeText(referralLink);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };

  //const createdDateFormat = props.ProfileDetails.createdTimestamp
  return (
    <section style={{ marginTop: "40px" }}>
      <Grid container spacing={2} className={classes.customerdatawrapper}>
        <Grid item xs={12} md={3} sm={3}>
          <h2>{props.labels.firstName}</h2>
          <p>{props.ProfileDetails.firstName || "N/A"}  </p>
        </Grid>
        <Grid item xs={12} md={3} sm={3}>
          <h2>{props.labels.lastName} </h2>
          <p> {props.ProfileDetails.lastName || "N/A"}</p>
        </Grid>
        <Grid item xs={12} md={3} sm={3}>
          <h2> {props.labels.username} </h2>
          <p> {props.ProfileDetails.username || "N/A"}</p>
        </Grid>
        <Grid item xs={12} md={3} sm={3}>
          <h2> {props.labels.email}  </h2>
          <p> {props.ProfileDetails.email || "N/A"}</p>
        </Grid>
        <Grid item xs={12} md={3} sm={3}>
          { showReferral && (
            <>
              <h2>Agent Referral Link</h2>
              <ButtonInc
                style={{ marginTop: 8 }}
                onClick={() => setOpen(true)}
              >
                Click here for your referral link
              </ButtonInc>
              <Dialog open={open} onClose={() => setOpen(false)}>
                <DialogTitle>Your Referral Link
                  <IconButton
                    aria-label="close"
                    onClick={() => setOpen(false)}
                    sx={{ position: 'absolute', right: 8, top: 8 }}
                    size="large"
                  >
                    <CloseIcon />
                  </IconButton>
                </DialogTitle>
                <DialogContent>
                  {referralLink !== 'N/A' ? (
                    <>
                      <a href={referralLink} target="_blank" rel="noopener noreferrer">{referralLink}</a>
                      <div>
                      <ButtonInc
                       
                        size="small"
                        style={{ marginTop: 8, marginLeft: 8 }}
                        onClick={handleCopy}
                      >
                        Copy Link
                      </ButtonInc>
                      </div>
                   
                      {copied && <span style={{ marginLeft: 8, color: 'green' }}>Copied!</span>}
                    </>
                  ) : "N/A"}
                </DialogContent>
              </Dialog>
            </>
          )}
        </Grid>

      </Grid>
    </section>
  )
}

export default ProfileDetails